import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Default = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  background-color: ${COLORS.gray60};
  color: #fff;
`;

export default Default;
